import React from "react";
import { Helmet } from "react-helmet-async";
import HeroBanner from "../../../Hero/HeroBanner";
import GoToPriceMultiple from "../GoToPrice/GoToPriceMultiple";
import HeroPicBig from "../../../.../../../../assets/medical/examinations/packages/meddoseg/meddoseg_banner_nagy.png";
import HeroPicSmall from "../../../../../assets/medical/examinations/packages/meddoseg/meddoseg_banner_kicsi.png";
import { examinationPackages } from "../../exams/examinationPackages";
import ExamCTA from "../../ExamCTA/ExamCTA";
import ExamContent from "../ExamContent/ExamContent";

const ExamPackageMeddoseg = () => {
  const meddosegPackages = examinationPackages[3].contains;

  // Create structured data for fertility testing packages
  const fertilityTestingStructuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "Meddőségi kivizsgálás - Bálint Analitika",
    description:
      "A Bálint Analitika laboratórium meddőségi kivizsgálás csomagjai: férfi és női panelek átfogó szűrésekkel.",
    relevantSpecialty: ["Gynecology", "Urology", "Fertility"],
    medicineSystem: "Conventional Medicine",
    usedToDiagnose: "Infertility",
    normalRange: "Varies by individual test",
    affectedBy: ["Age", "Hormonal balance", "Genetic factors"],
    procedure: "Blood test panel and specialized fertility examinations",
    serviceProvider: {
      "@type": "MedicalBusiness",
      name: "Bálint Analitika Laboratórium",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Kondorfa utca 6.",
        addressLocality: "Budapest",
        postalCode: "1116",
        addressRegion: "XI. kerület",
        addressCountry: "HU",
      },
    },
    offers: {
      "@type": "Offer",
      availability: "InStock",
      priceCurrency: "HUF",
      priceSpecification: {
        "@type": "PriceSpecification",
        price: "Varies by package",
      },
    },
  };

  return (
    <>
      <Helmet>
        <title>
          Meddőségi kivizsgálás | Termékenységi vizsgálatok | Bálint Analitika
        </title>
        <meta
          name="description"
          content="Meddőségi kivizsgálás csomagok nőknek és férfiaknak a Bálint Analitika budapesti laboratóriumában. Átfogó termékenységi vizsgálatok, szűrések és tanácsadás szakértőktől."
        />
        <meta
          name="keywords"
          content="meddőségi kivizsgálás, termékenységi teszt, női panel, férfi panel, meddőség okai, laborvizsgálatok, fertilitás Budapest"
        />
        <link
          rel="canonical"
          href="https://balintanalitika.hu/orvosdiagnosztika/vizsgalatok/csomagok/meddoseg"
        />
        <script type="application/ld+json">
          {JSON.stringify(fertilityTestingStructuredData)}
        </script>
      </Helmet>

      <HeroBanner
        srcBig={HeroPicBig}
        srcSmall={HeroPicSmall}
        alt="Meddőségi kivizsgálás és termékenységi vizsgálatok a Bálint Analitika laboratóriumban"
      />

      <main className="exam-package-page container">
        <header className="exam-package-header">
          <h1 className="heading-primary">Meddőségi kivizsgálás csomagok</h1>
          <p className="exam-company-contact-text">
            A Bálint Analitika laboratórium átfogó meddőségi kivizsgálás
            csomagokat kínál nőknek és férfiaknak egyaránt. Vizsgálataink
            segítenek feltárni a termékenységgel kapcsolatos problémák
            lehetséges okait és hozzájárulnak a megfelelő kezelési terv
            kidolgozásához.
          </p>
        </header>

        <section className="exam-package-container">
          <h2 className="visually-hidden">Meddőségi kivizsgálások típusai</h2>

          {meddosegPackages.map((packageItem, index) => (
            <ExamContent
              key={index}
              title={packageItem.name}
              suggestedTo={packageItem.suggestedTo}
              items={packageItem.items}
              isPackage={true}
              itemType="https://schema.org/MedicalTest"
            />
          ))}

          <div className="exam-package-additional-info">
            <h3 className="heading-tertiary">
              Miért fontos a meddőségi kivizsgálás?
            </h3>
            <p className="exam-company-contact-text">
              A meddőség a párok jelentős részét érinti, és mind nőket, mind
              férfiakat érinthet. A laboratóriumi vizsgálatok nélkülözhetetlen
              eszközök a meddőség okainak megértésében és a megfelelő kezelési
              stratégiák kidolgozásában. Vizsgálataink Budapest XI. kerületében,
              a legkorszerűbb felszerelésekkel és szakképzett személyzettel
              történnek.
            </p>

            <h3 className="heading-tertiary">Mikor javasolt a kivizsgálás?</h3>
            <ul className="exam-package-list">
              <li>
                Ha egy éve vagy hosszabb ideje próbálkoznak gyermeket vállalni
                sikertelenül
              </li>
              <li>Ha a nő 35 évnél idősebb és hat hónapja próbálkoznak</li>
              <li>
                Ha ismert egészségügyi problémák állnak fenn (pl. endometriózis,
                policisztás petefészek szindróma)
              </li>
              <li>Korábbi vetélések után</li>
              <li>Hormonális rendellenességek gyanúja esetén</li>
            </ul>
          </div>

          <GoToPriceMultiple />

          <div
            className="exam-package-contact"
            itemScope
            itemType="https://schema.org/MedicalOrganization"
          >
            <h3 className="heading-tertiary">Szakértői tanácsadás</h3>
            <p  className="exam-company-contact-text">
              A laboratóriumi eredmények kiértékelésében szakértői konzultációt
              biztosítunk. Keressen bennünket bizalommal a{" "}
              <a href="/orvosdiagnosztika/kapcsolat" itemProp="url">
                kapcsolat
              </a>{" "}
              oldalon található elérhetőségeken vagy a lenti gombokra kattintva.
            </p>
            <ExamCTA />
          </div>
        </section>
      </main>
    </>
  );
};

export default ExamPackageMeddoseg;
